export default __webpack_public_path__ + "static/media/03.32a58cb8.png";